import { TYPE, POSITION, createToastInterface } from 'vue-toastification';

import '@ui-kit/styles/notifications/index.scss';
import BaseNotification from '@ui-kit/components/notification/base-notification.vue';
import closeNotificationButton from '@ui-kit/components/notification/close-notification-button.vue';
import SwordIcon from '@ui-kit/components/icons/SwordIcon.vue';

// Create the interface
const pluginOptions = {
  closeOnClick: false,
  transitionDuration: 500,
  closeButton: closeNotificationButton,
  newestOnTop: false,
  position: POSITION.TOP_CENTER,
  timeout: 5000,
  icon: false,
  transition: {
    enter: 'Vue-Toastification__fade-enter-active',
    leave: 'Vue-Toastification__fade-leave-active',
    move: 'fade-move'
  }
};

const CUSTOM_TYPE = {
  NEUTRAL: 'neutral',
};

const ALL_TYPES = Object.values(TYPE).concat(Object.values(CUSTOM_TYPE));

const toastInterface = createToastInterface(pluginOptions);

// Adding support for WUK icons lib by string
const toast = (content, options) => {
  let computedOptions = options;
  if (options && options.icon && typeof options.icon === 'string') {
    SwordIcon.props.name.default = options.icon;
    computedOptions = { ...options, icon: SwordIcon };
  }
  toastInterface(content, computedOptions);
};
toast.clear = toastInterface.clear;

// Creating default for all shorthand types, including custom ones
ALL_TYPES.forEach(type => {
  toast[type] = (toastBody, optionsOverwrite) => {
    const useDefaultComponent = typeof toastBody === 'string';
    let bodyConfig = toastBody;
    if (useDefaultComponent) {
      bodyConfig = {
        component: BaseNotification,
        props: {
          textMessage: toastBody
        },
      };
    }
    toast(bodyConfig, { type, ...optionsOverwrite });
  };
});

const NOTIFY_ALIAS = '$notify';

export {
  NOTIFY_ALIAS,
  toast
};
